export const SECTOR_LABELS: Record<string, string> = {
  ifa: 'Independent Fostering Agency',
  ich: "Independent Children's Home",
  gcs: "General Children's Services",
  isa: 'Independent Supported Accommodation',
  la: 'Local Authority',
  leaving_care: 'Leaving Care',
  education: 'Education',
  // Long-form slugs returned by `GET /sectors/`. The Figma copy renames
  // "Semi Independent Living" → "Independent Supported Accommodation"; the
  // backend still ships the old name (see backend.request.md).
  'independent-fostering-agency': 'Independent Fostering Agency',
  'independent-childrens-home': "Independent Children's Home",
  'general-childrens-services': "General Children's Services",
  'semi-independent-living': 'Independent Supported Accommodation',
  'local-authority': 'Local Authority',
};

export function getSectorLabel(sector: string): string {
  return SECTOR_LABELS[sector] ?? sector;
}
